import React from "react";
import './index.css'
import { secureUrl } from "../../../../utils/sortArray/secureUrl";
import { useNavigate } from "react-router-dom";
import FifaCard from "./components/FifaCard";

const PlantillaGrid = ({plantilla})=>{
    const navigate = useNavigate();
    return(
    <div className="plantilla-grid-players" >
        {
            plantilla?.map((jugador, index)=>(
                <FifaCard player={jugador?.jugador} />

            ))
        }

    </div>)
}

export default PlantillaGrid